// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__2hE_H","errorLogs":"styles_errorLogs__YN10a"};